import { render, staticRenderFns } from "./QuizPage.vue?vue&type=template&id=e538798a&scoped=true&"
import script from "./QuizPage.vue?vue&type=script&lang=js&"
export * from "./QuizPage.vue?vue&type=script&lang=js&"
import style0 from "./QuizPage.vue?vue&type=style&index=0&id=e538798a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e538798a",
  null
  
)

export default component.exports